module.exports = __webpack_public_path__ + "static/jameda-green-mobile-239a947d546b10689370d916edb8ab95.jpg";